var Event = require('./event');
var Adapter = {
  Event: Event
};
module.exports = Adapter;